/**
 * The prototype's footer: #fafaf9, top border, © left, links right,
 * "All systems operational" with a green dot. Links are static for now
 * (the sites they point at do not exist yet).
 */
const LINKS = ['Help center', 'Supported formats', "What’s new", 'Privacy', 'Terms'];

export function Footer() {
  return (
    <div style={{ marginTop: 'auto', borderTop: '1px solid #ebebea', background: '#fafaf9' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, padding: '18px 28px', maxWidth: 1440, width: '100%', margin: '0 auto', boxSizing: 'border-box', flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12.5, color: '#8a8a8f' }}>© 2026 TileRiver Inc.</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, fontSize: 12.5 }}>
          {LINKS.map((l) => (
            <a key={l} href="#" onClick={(e) => e.preventDefault()} className="tr-hover-ink" style={{ color: '#6b6b70', textDecoration: 'none' }}>
              {l}
            </a>
          ))}
          <a href="#" onClick={(e) => e.preventDefault()} className="tr-hover-ink" style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6b6b70', textDecoration: 'none' }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#2f9e44' }} />
            All systems operational
          </a>
        </div>
      </div>
    </div>
  );
}
